import { createRouter } from "@tanstack/react-router";
import { rootRoute } from "./routes/__root";
import { batchDetailRoute } from "./routes/batches.$root";
import { batchExplorerRoute } from "./routes/batches.index";
import { dashboardRoute } from "./routes/dashboard";
import { eventDetailRoute } from "./routes/events.$hash";
import { eventSearchRoute } from "./routes/events.index";
import { helpRoute } from "./routes/help";
import { loanAuditRoute } from "./routes/loans.$loanId";
import { loanLookupRoute } from "./routes/loans.index";
import { notFoundRoute } from "./routes/not-found";
import { reportDetailRoute } from "./routes/reports.$id";
import { reportsListRoute } from "./routes/reports.index";

const routeTree = rootRoute.addChildren([
	dashboardRoute,
	eventSearchRoute,
	eventDetailRoute,
	loanLookupRoute,
	loanAuditRoute,
	batchExplorerRoute,
	batchDetailRoute,
	reportsListRoute,
	reportDetailRoute,
	helpRoute,
	notFoundRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
